const ColumnChart = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 5a1.5 1.5 0 0 1 1.5-1.5h1A1.5 1.5 0 0 1 14 5v13a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 10 18zm1.5-.5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zM4 13a1.5 1.5 0 0 1 1.5-1.5h1A1.5 1.5 0 0 1 8 13v5a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 4 18zm1.5-.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1A.5.5 0 0 0 7 18v-5a.5.5 0 0 0-.5-.5zM17.5 7.5A1.5 1.5 0 0 0 16 9v9a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 20 18V9a1.5 1.5 0 0 0-1.5-1.5zM17 9a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"
      clipRule="evenodd"
    />
  </>
)
export default ColumnChart
